import log1 from '../../assets/images/log_1.png';
import log2 from '../../assets/images/log_2.png';
import log3 from '../../assets/images/log_3.png';
import log4 from '../../assets/images/log_4.png';
import log5 from '../../assets/images/log_5.png';
import log6 from '../../assets/images/log_6.png';

interface BlogPost {
  id: string;
  title: string;
  description: string;
  date: string;
  image: string;
  category?: string;
}

const blogPosts: BlogPost[] = [
  {
    id: 'real-time-tracking',
    title: 'HOW REAL-TIME TRACKING IS CHANGING CUSTOMER EXPECTATIONS',
    description:
      "Discover how live updates from pickup to delivery are no longer just a perk — they're now a customer expectation. Here's how Speedyssey makes it seamless.",
    date: 'JAN 12, 2025',
    image: log1,
    category: 'Customer Experience',
  },
  {
    id: 'future-logistics-africa',
    title: "THE FUTURE OF LOGISTICS IN AFRICA: WHAT'S NEXT?",
    description:
      "A deep dive into how emerging tech, mobile-first logistics, and last-mile innovation are reshaping African commerce. Here's how Speedyssey makes it seamless.",
    date: 'JAN 12, 2025',
    image: log2,
    category: 'Industry Trends',
  },
  {
    id: 'seller-dashboard-features',
    title: 'USING THE SELLER DASHBOARD: 5 UNDERRATED FEATURES YOU SHOULD KNOW',
    description:
      'You might be underutilizing some powerful features. Here\'s how to streamline your order management and reduce failed deliveries.',
    date: 'JAN 12, 2025',
    image: log3,
    category: 'Product Updates',
  },
  {
    id: 'meet-our-sellers',
    title: 'MEET OUR SELLERS: THE FASHION BRAND THAT CUT DELIVERY DELAYS BY 60%',
    description:
      'We sat down with ZARA Express, one of our top sellers, to learn how they scaled faster with Speedyssey\'s Seller Dashboard and priority zones.',
    date: 'JAN 12, 2025',
    image: log4,
    category: 'Customer Stories',
  },
  {
    id: 'smart-routing-ai',
    title: 'SMART ROUTING WITH AI: BOOSTING DELIVERY SPEEDS IN URBAN AREAS',
    description:
      'An inside look at how AI-powered routing algorithms reduce delivery times and lower operational costs for businesses.',
    date: 'JAN 12, 2025',
    image: log5,
    category: 'Technology',
  },
  {
    id: 'sustainability-initiative',
    title: 'OUR NEW SUSTAINABILITY INITIATIVE: GREEN DELIVERIES BY 2030',
    description:
      'Find out how Speedyssey is investing in green technologies and eco-friendly packaging to minimize our carbon footprint.',
    date: 'JAN 12, 2025',
    image: log6,
    category: 'Company News',
  },
];

function Posts() {
  return (
    <section className="bg-white py-20 px-4">
      <div className="container sm:px-10 px-3 mx-auto">
        {/* Blog Posts Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-12">
          {blogPosts.map((post) => (
            <article key={post.id} className="group cursor-pointer">
              {/* Image */}
              <div className="relative overflow-hidden mb-6">
                <img
                  src={post.image}
                  alt={post.title}
                  className="w-full h-[400px] object-cover transition-transform duration-300 group-hover:scale-105"
                />
                <div className="absolute inset-0 bg-black/0 group-hover:bg-black/10 transition-colors duration-300" />
              </div>

              {/* Content */}
              <div>
                <h3
                  className="text-2xl font-bold text-[#2C2C2C] mb-4 leading-tight group-hover:text-[#F55109] transition-colors duration-300"
                  style={{ fontFamily: 'Antonio, sans-serif' }}
                >
                  {post.title}
                </h3>

                <p className="text-gray-600 text-base leading-relaxed mb-4">
                  {post.description}
                </p>

                <div className="flex items-center justify-between">
                  <span className="text-[#F55109] text-sm font-semibold">{post.date}</span>
                  {post.category && (
                    <span className="text-gray-400 text-sm">{post.category}</span>
                  )}
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}

export default Posts;
